import BlockedCookiesModal from './blocked-cookies-modal';

export default BlockedCookiesModal;
